export default __webpack_public_path__ + "static/videos-adc9df07491a27c8c428f8570ac6ebf5.png";